// components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import StoreRequestPopup from './StoreRequestPopup';
import logo from './assets/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setIsPopupOpen(true);
    closeMobileMenu();
  };

  const handleDemoClick = (e) => {
    e.preventDefault();
    window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
    closeMobileMenu();
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About us', path: '/about' },
    { name: 'Demo', path: '/demo', isExternal: true, externalUrl: 'https://demo-site.creativepulse.pk/' },
    { name: 'Blogs', path: '/blogs' },
    { name: 'Contact us', path: '/contact' }
  ];

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="nav-container">

          {/* Left Side - Logo */}
          <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" className="logo-img" />
          </Link>

          {/* Mobile Menu Button */}
          <div className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          {/* Center - Nav Items */}
          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            {navItems.map((item, index) => (
              <li key={index} className="nav-item">
                {item.isExternal ? (
                  <a
                    href={item.externalUrl}
                    className="nav-link"
                    onClick={handleDemoClick}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                ) : (
                  <Link
                    to={item.path}
                    className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    onClick={closeMobileMenu}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>

          {/* Right Side - CTA Button */}
          <div className="nav-button">
            <a href="#" className="btn-get-started" onClick={handleGetStartedClick}>
              Get Started
            </a>
          </div>

        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="mobile-backdrop" onClick={closeMobileMenu}></div>
      )}

      <StoreRequestPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
};

export default Navbar;